"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * The number of arguments each bundled formulajs function declares, for the functions that never
 * read `arguments` beyond its length: those cannot see an argument past this count, so one placed
 * there is ignored by the function.
 *
 * Generated from @builttocreate/hot-formula-parser 5.0.2 dist/formula-parser.js, the formulajs that
 * actually runs (it differs from the standalone @handsontable/formulajs package: FLOOR declares 2
 * parameters in the bundle and 3 in the package). Aliases such as NORMSDIST = NORM.S.DIST are
 * followed, through the index module the parser calls. Checked against the running parser: for
 * every name listed, the value of an argument past this count never changes the result. A name
 * left out (a variadic function, or definitions that disagree) counts every argument as read.
 *
 * tableFormulas.test.js re-derives this table from the installed bundle and asserts it is equal,
 * so a parser upgrade that changes a signature fails loudly instead of silently.
 */
var FormulaFixedArity = {
  ABS: 1,
  ACCRINT: 7,
  ACOS: 1,
  ACOSH: 1,
  ACOT: 1,
  ACOTH: 1,
  ADD: 2,
  AGGREGATE: 4,
  ARABIC: 1,
  ASIN: 1,
  ASINH: 1,
  ATAN: 1,
  ATAN2: 2,
  ATANH: 1,
  AVERAGEIF: 3,
  BASE: 3,
  BESSELI: 2,
  BESSELJ: 2,
  BESSELK: 2,
  BESSELY: 2,
  'BETA.DIST': 6,
  'BETA.INV': 5,
  BETADIST: 6,
  BETAINV: 5,
  BIN2DEC: 1,
  BIN2HEX: 2,
  BIN2OCT: 2,
  'BINOM.DIST': 4,
  'BINOM.DIST.RANGE': 4,
  'BINOM.INV': 3,
  BINOMDIST: 4,
  BITAND: 2,
  BITLSHIFT: 2,
  BITOR: 2,
  BITRSHIFT: 2,
  BITXOR: 2,
  CEILING: 3,
  CEILINGMATH: 3,
  CEILINGPRECISE: 3,
  CHAR: 1,
  'CHISQ.DIST': 3,
  'CHISQ.DIST.RT': 2,
  'CHISQ.INV': 2,
  'CHISQ.INV.RT': 2,
  CLEAN: 1,
  CODE: 1,
  COLUMN: 2,
  COLUMNS: 1,
  COMBIN: 2,
  COMBINA: 2,
  COMPLEX: 3,
  CONFIDENCE: 3,
  'CONFIDENCE.NORM': 3,
  'CONFIDENCE.T': 3,
  CONVERT: 3,
  CORREL: 2,
  COS: 1,
  COSH: 1,
  COT: 1,
  COTH: 1,
  COUNTIF: 2,
  COUNTIN: 2,
  'COVARIANCE.P': 2,
  'COVARIANCE.S': 2,
  CSC: 1,
  CSCH: 1,
  CUMIPMT: 6,
  CUMPRINC: 6,
  DATE: 3,
  DATEVALUE: 1,
  DAY: 1,
  DAYS: 2,
  DAYS360: 3,
  DB: 5,
  DDB: 5,
  DEC2BIN: 2,
  DEC2HEX: 2,
  DEC2OCT: 2,
  DECIMAL: 2,
  DEGREES: 1,
  DELTA: 2,
  DIVIDE: 2,
  DOLLARDE: 2,
  DOLLARFR: 2,
  E: 0,
  EDATE: 2,
  EFFECT: 2,
  EOMONTH: 2,
  EQ: 2,
  ERF: 2,
  ERFC: 1,
  EVEN: 1,
  EXACT: 2,
  EXP: 1,
  'EXPON.DIST': 3,
  EXPONDIST: 3,
  'F.DIST': 4,
  'F.DIST.RT': 3,
  'F.INV': 3,
  'F.INV.RT': 3,
  FACT: 1,
  FACTDOUBLE: 1,
  FALSE: 0,
  FDIST: 4,
  FDISTRT: 3,
  FIND: 3,
  FINV: 3,
  FINVRT: 3,
  FISHER: 1,
  FISHERINV: 1,
  FLOOR: 3,
  FORECAST: 3,
  FREQUENCY: 2,
  FV: 5,
  FVSCHEDULE: 2,
  GAMMA: 1,
  'GAMMA.DIST': 4,
  'GAMMA.INV': 3,
  GAMMADIST: 4,
  GAMMAINV: 3,
  GAMMALN: 1,
  'GAMMALN.PRECISE': 1,
  GAUSS: 1,
  GESTEP: 2,
  GROWTH: 4,
  GTE: 2,
  HEX2BIN: 2,
  HEX2DEC: 1,
  HEX2OCT: 2,
  HOUR: 1,
  HTML2TEXT: 1,
  'HYPGEOM.DIST': 5,
  HYPGEOMDIST: 5,
  IF: 3,
  IMABS: 1,
  IMAGINARY: 1,
  IMARGUMENT: 1,
  IMCONJUGATE: 1,
  IMCOS: 1,
  IMCOSH: 1,
  IMCOT: 1,
  IMCSC: 1,
  IMCSCH: 1,
  IMDIV: 2,
  IMEXP: 1,
  IMLN: 1,
  IMLOG10: 1,
  IMLOG2: 1,
  IMPOWER: 2,
  IMREAL: 1,
  IMSEC: 1,
  IMSECH: 1,
  IMSIN: 1,
  IMSINH: 1,
  IMSQRT: 1,
  IMSUB: 2,
  IMTAN: 1,
  INT: 1,
  INTERCEPT: 2,
  INTERVAL: 1,
  IPMT: 6,
  IRR: 2,
  ISBINARY: 1,
  ISBLANK: 1,
  ISEVEN: 1,
  ISLOGICAL: 1,
  ISNONTEXT: 1,
  ISNUMBER: 1,
  ISODD: 1,
  ISOWEEKNUM: 1,
  ISPMT: 4,
  ISTEXT: 1,
  JOIN: 2,
  LARGE: 2,
  LEFT: 2,
  LEN: 1,
  LINEST: 2,
  LN: 1,
  LOG: 2,
  LOG10: 1,
  LOGEST: 2,
  'LOGNORM.DIST': 4,
  'LOGNORM.INV': 3,
  LOGNORMDIST: 4,
  LOGNORMINV: 3,
  LOWER: 1,
  LT: 2,
  LTE: 2,
  MATCH: 3,
  MID: 3,
  MINUS: 2,
  MINUTE: 1,
  MIRR: 3,
  MOD: 2,
  MONTH: 1,
  MROUND: 2,
  MULTIPLY: 2,
  NE: 2,
  'NEGBINOM.DIST': 4,
  NEGBINOMDIST: 4,
  NETWORKDAYS: 3,
  NOMINAL: 2,
  'NORM.DIST': 4,
  'NORM.INV': 3,
  'NORM.S.DIST': 2,
  'NORM.S.INV': 1,
  NORMDIST: 4,
  NORMINV: 3,
  NORMSDIST: 2,
  NORMSINV: 1,
  NOT: 1,
  NOW: 0,
  NPER: 5,
  OCT2BIN: 2,
  OCT2DEC: 1,
  OCT2HEX: 2,
  ODD: 1,
  PDURATION: 3,
  PEARSON: 2,
  PERCENTILEEXC: 2,
  PERCENTILEINC: 2,
  PERCENTRANKEXC: 3,
  PERCENTRANKINC: 3,
  PERMUT: 2,
  PERMUTATIONA: 2,
  PHI: 1,
  PI: 0,
  PMT: 5,
  'POISSON.DIST': 3,
  POISSONDIST: 3,
  POW: 2,
  POWER: 2,
  PPMT: 6,
  PROB: 4,
  PROPER: 1,
  PV: 5,
  'QUARTILE.EXC': 2,
  'QUARTILE.INC': 2,
  QUARTILEEXC: 2,
  QUARTILEINC: 2,
  QUOTIENT: 2,
  RADIANS: 1,
  RAND: 0,
  RANDBETWEEN: 2,
  'RANK.AVG': 3,
  'RANK.EQ': 3,
  RANKAVG: 3,
  RANKEQ: 3,
  RATE: 6,
  REFERENCE: 2,
  REGEXEXTRACT: 2,
  REGEXMATCH: 3,
  REGEXREPLACE: 3,
  REPLACE: 4,
  REPT: 2,
  RIGHT: 2,
  ROMAN: 1,
  ROUND: 2,
  ROUNDDOWN: 2,
  ROUNDUP: 2,
  ROW: 2,
  ROWS: 1,
  RRI: 3,
  RSQ: 2,
  SEARCH: 3,
  SEC: 1,
  SECH: 1,
  SECOND: 1,
  SERIESSUM: 4,
  SIGN: 1,
  SIN: 1,
  SINH: 1,
  SLN: 3,
  SLOPE: 2,
  SMALL: 2,
  SPLIT: 2,
  SQRT: 1,
  SQRTPI: 1,
  STANDARDIZE: 3,
  STEYX: 2,
  SUBSTITUTE: 4,
  SUBTOTAL: 2,
  SUMIF: 2,
  SUMX2MY2: 2,
  SUMX2PY2: 2,
  SUMXMY2: 2,
  SYD: 4,
  T: 1,
  'T.DIST': 3,
  'T.DIST.2T': 2,
  'T.DIST.RT': 2,
  'T.INV': 2,
  'T.INV.2T': 2,
  TAN: 1,
  TANH: 1,
  TBILLEQ: 3,
  TBILLPRICE: 3,
  TBILLYIELD: 3,
  TDIST: 3,
  TDISTRT: 2,
  TIME: 3,
  TIMEVALUE: 1,
  TINV: 2,
  TODAY: 0,
  TRANSPOSE: 1,
  TREND: 3,
  TRIM: 1,
  TRIMMEAN: 2,
  TRUE: 0,
  TRUNC: 2,
  UNICHAR: 1,
  UNICODE: 1,
  UPPER: 1,
  WEEKDAY: 2,
  WEEKNUM: 2,
  'WEIBULL.DIST': 4,
  WEIBULLDIST: 4,
  WORKDAY: 3,
  XNPV: 3,
  YEAR: 1,
  YEARFRAC: 3
};
var _default = exports["default"] = FormulaFixedArity;